import config from '@/api/config'

// Plan Public IDs
export const PLAN_PUBLIC_IDS = {
  // Common Plans
  free: "free",
  freeTrial: "free_trial",

  // New Plans
  paddle_bronze_monthly: "paddle_bronze_monthly",
  paddle_bronze_yearly: "paddle_bronze_yearly",
  paddle_silver_monthly: "paddle_silver_monthly",
  paddle_silver_yearly: "paddle_silver_yearly",
  paddle_gold_monthly: "paddle_gold_monthly",
  paddle_gold_yearly: "paddle_gold_yearly",

  // Legacy
  paddle_starter: "paddle_starter",
  paddle_single_annual: "paddle_single_annual",
  paddle_pro: "paddle_pro",
  paddle_pro_annual: "paddle_pro_annual",
  paddle_scale: "paddle_scale",
  paddle_scale_annual: "paddle_scale_annual",
  paddle_enterprise: "paddle_enterprise",
  paddle_enterprise_annual: "paddle_enterprise_annual",
};

export const planPublicIds = PLAN_PUBLIC_IDS

// Paid Plan ID Map
export const PLAN_ID_MAP = {
  // New Plans
  [PLAN_PUBLIC_IDS.paddle_bronze_monthly]: config.paddle.bronzeMonthlyId,
  [PLAN_PUBLIC_IDS.paddle_bronze_yearly]: config.paddle.bronzeYearlyId,
  [PLAN_PUBLIC_IDS.paddle_silver_monthly]: config.paddle.silverMonthlyId,
  [PLAN_PUBLIC_IDS.paddle_silver_yearly]: config.paddle.silverYearlyId,
  [PLAN_PUBLIC_IDS.paddle_gold_monthly]: config.paddle.goldMonthlyId,
  [PLAN_PUBLIC_IDS.paddle_gold_yearly]: config.paddle.goldYearlyId,

  // Legacy Plans
  [PLAN_PUBLIC_IDS.paddle_pro]: config.paddle.planId,
  [PLAN_PUBLIC_IDS.paddle_pro_annual]: config.paddle.annualProId,
  [PLAN_PUBLIC_IDS.paddle_scale]: config.paddle.scaleId,
  [PLAN_PUBLIC_IDS.paddle_scale_annual]: config.paddle.annualScaleId,
  [PLAN_PUBLIC_IDS.paddle_enterprise]: config.paddle.enterpriseId,
  [PLAN_PUBLIC_IDS.paddle_enterprise_annual]: config.paddle.annualEnterpriseId,
  [PLAN_PUBLIC_IDS.paddle_single_annual]: config.paddle.singlePlanId,
  [PLAN_PUBLIC_IDS.paddle_starter]: config.paddle.starterPlanId,
};


